import { calculateFastfoot } from "./fastfootEstimator";

const data = {
  extraWidth: 10,
  overlap: 1,
  costFF50: 99.19,
  costFF50C: 9.84,
  costFF62: 123.73,
  costFF62C: 10.77,
  costFF74: 147.31,
  costFF74C: 13.11,
  stakeSpacing: 6,
  cleatSpacing: 6,
  stakeInGround: 0.25,
  woodWaste: 0.1,
  stakeReuseResFF: 4,
  screedReuseResFF: 14,
  stakeLength: 2.0,
  formReuseResLumber: 2,
  stakeReuseResLumber: 1,
  oneByFourAdj: 1.65,
  twoByFourAdj: 0.94,
  twoByTwelveAdj: 0.08,
  twoBySixAdj: 0.95,
  twoByEightAdj: 0.98,
  levelAdjFF: 0.1,
  cleanAdjFF: 0.1,
  stripAdjFF: 0.2,
  heightAdjFF: 1.2,
  weightLumberPerSqFt: 4.37,
  minToLevelExcavationPer10Ft: 8,
  minToDriveStakePair: 3,
  minToSetUpFormPerPound: 0.25,
  minInstallFFPerRoll: 10,
  minToStripForm: 0.06,
  minToCleanForm: 0.05,
  minToCarryFormPerPound: 0.04,
  minToLayoutOneResCorner: 12,
  minToLayout12Feet: 18,
  supportSpacing: 5,
  oneByFourStakeLength: 2.0,
  oneByFourStakeReuse: 1.0,
  stakeReuseComFF: 3,
  screedReuseComFF: 8,
  stakeReuseComLumber: 2,
  formReuseComLumber: 2,
  kickerReuse: 3.0,
  twoByFourPlywoodFrameReuse: 1.2,
  plywoodWeightPerSquareFoot: 1.9,
  plywoodAdj: 1.36,
  minToLayoutOneComCorner: 3,
};

const getInputsData = (form, columns) => {
    let result = []
    do {
        result.push(
            {
                width: +form[`width-${columns}`].value,
                height: +form[`height-${columns}`].value,
                length: +form[`length-${columns}`].value,
                quantity: +form[`qty-${columns}`].value,
                lumberCost: +form['lumberCost'].value,
                plywoodCost: +form['plywoodCost']?.value,
                labourCost: +form['labourCost'].value,
            }
        )
        columns -= 1
    } while(columns > 0)

    return result.reverse()
}

const calculateFields = (resultData, field) => {
    const qty = resultData.reduce((acc, curr) => acc + curr[field], 0)
    return qty > 0 ? qty : 0
}

export const runCostCompare = () => {
    const form = calc_ff_form || document.querySelector('#calc_ff_form');
    const type = form.dataset.type;
    calculateFastfoot(type);

    const widthInputRow = form.querySelector("#widthInputRow");
    const columnQty = widthInputRow.childElementCount -1;
    const inputsData = getInputsData(form, columnQty)
    const resultData = []

    inputsData.forEach(footingData => resultData.push(
        type === 'commercial'
        ? commercialCostCompare(footingData)
        : residentialCostCompare(footingData)
    )) 

    const materialCostFF = calculateFields(resultData, "materialCostFF")
    const lumberCostFF = calculateFields(resultData, "lumberCostFF")
    const labourCostFF = calculateFields(resultData, "labourCostFF")
    const materialCostPlywood = calculateFields(resultData, "materialCostPlywood")
    const lumberCostPlywood = calculateFields(resultData, "lumberCostPlywood")
    const labourCostPlywood = calculateFields(resultData, "labourCostPlywood")

    totalMaterialCostFF.innerHTML = "$"+materialCostFF
    totalLumberCostFF.innerText = "$"+lumberCostFF
    totalMaterialCostPlywood.innerText = "$"+materialCostPlywood
    totalLumberCostPlywood.innerText = "$"+lumberCostPlywood
    totalLabourCostFF.innerText = "$"+labourCostFF
    totalLabourCostPlywood.innerText = "$"+labourCostPlywood
    totalCostFF.innerText = "$"+(materialCostFF + labourCostFF + lumberCostFF)
    totalCostPlywood.innerText = "$"+(materialCostPlywood + labourCostPlywood + lumberCostPlywood)

    const totalFF = document.querySelector('#totalCostFF')
    const totalLamber = document.querySelector('#totalCostPlywood')
    const isFF = +totalFF.innerText.substring(1) < +totalLamber.innerText.substring(1)
    totalFF.innerHTML = `<i class="fa ${isFF ? "fa-check" : "fa-times"} me-1" aria-hidden="true"></i>` + totalFF.innerText
    totalLamber.innerHTML = `<i class="fa ${isFF ? "fa-times" : "fa-check"} me-1" aria-hidden="true"></i>` + totalLamber.innerText
    totalFF.style.color = isFF ? "yellowgreen" : "red"
    totalLamber.style.color = isFF ? "red" : "yellowgreen"
}

const residentialCostCompare = ({ width, height, length, quantity, lumberCost, labourCost }) => {
    const resData = {}
    let ff50RollQty = 0;
    let ff62RollQty = 0;
    let ff74RollQty = 0;
    let fabricCostFF = 0;

    switch (true) {
        case (width + height * 2 + data.extraWidth <= 50):
            ff50RollQty = ((length - quantity * (8 - 2 * data.overlap)) / 100) * (1 + data.overlap / 100)
            fabricCostFF = quantity * data.costFF50C + ff50RollQty * data.costFF50
            break
        case (width + height * 2 + data.extraWidth > 50 && width + height * 2 + data.extraWidth <= 62):
            ff62RollQty = ((length - quantity * (8 - 2 * data.overlap)) / 100) * (1 + data.overlap / 100)
            fabricCostFF = quantity * data.costFF62C + ff62RollQty * data.costFF62
            break
        case (width + height * 2 + data.extraWidth > 62 && width + height * 2 + data.extraWidth <= 74):
            ff74RollQty = ((length - quantity * (8 - 2 * data.overlap)) / 100) * (1 + data.overlap / 100)
            fabricCostFF = quantity * data.costFF74C + ff74RollQty * data.costFF74
            break
        case (width + height * 2 + data.extraWidth > 74 && height <= 50 / 2):
            ff50RollQty = (length / 100) * (1 + data.overlap / 100) * 2
            fabricCostFF = ff50RollQty * data.costFF50
            break
        case (width + height * 2 + data.extraWidth > 74 && height <= 62 / 2):
            ff62RollQty = (length / 100) * (1 + data.overlap / 100) * 2
            fabricCostFF = ff62RollQty * data.costFF62
            break
        case (width + height * 2 + data.extraWidth > 74 && height <= 74 / 2):
            ff74RollQty = (length / 100) * (1 + data.overlap / 100) * 2
            fabricCostFF = ff74RollQty * data.costFF74
            break
        case (width + height * 2 + data.extraWidth > 74 && height > 74 / 2):
            alert('Contact Fab-Form (888)303-3278 to discuss deep footings')
            break
    }

    const stakeLength = height / 12 * (1 + data.stakeInGround) * length * 2 / data.stakeSpacing * (1 + data.woodWaste)
    const cleatLength = width / 12 * length / data.cleatSpacing * (1 + data.woodWaste)
    const oneByFourCost = lumberCost / 1000 / 3 * data.oneByFourAdj
    const twoByFourCost = lumberCost / 1000 / 8 * 12 * data.twoByFourAdj
    const stakeCostFF = stakeLength * oneByFourCost / data.stakeReuseResFF
    const cleatCostFF = cleatLength * oneByFourCost
    const screedCostFF = twoByFourCost * (length + quantity * 2) * 2 * (1 + data.woodWaste) / data.screedReuseResFF
    const stakeCostLumber = stakeLength * oneByFourCost * data.stakeReuseResLumber
    const cleatCostLumber = cleatLength * oneByFourCost
    const formCostLumber = height < 12
        ? lumberCost / 1000 * 2 * height / 12 * (length + quantity * 2) / data.formReuseResLumber * (1 + data.woodWaste)
        : lumberCost * (1 + data.twoByTwelveAdj) / 1000 * 2 * height / 12 * (length + quantity * 2) / data.formReuseResLumber * (1 + data.woodWaste)
    const formAreaFF = 3.5 / 12 * length * (1 + data.woodWaste)
    const formAreaLumber = height / 12 * length * (1 + data.woodWaste)
    const formWeightFF = formAreaFF * data.weightLumberPerSqFt
    const formWeightLumber = formAreaLumber * data.weightLumberPerSqFt

    const minutesFF = (formWeightFF * data.minToCarryFormPerPound) + (length / 10 * data.minToLevelExcavationPer10Ft * data.levelAdjFF) + 
        (length / data.stakeSpacing * data.minToDriveStakePair) + (formWeightFF * data.minToSetUpFormPerPound) + (data.minInstallFFPerRoll * length / 100) + 
        (data.minToStripForm * formAreaFF * data.stripAdjFF) + (data.minToCleanForm * formAreaFF * data.cleanAdjFF) + 
        (data.minToLayoutOneResCorner * quantity + data.minToLayout12Feet * length / 20)
        
    const minutesLumber = (formWeightLumber * data.minToCarryFormPerPound) + (length / 10 * data.minToLevelExcavationPer10Ft) +
        (length / data.stakeSpacing * data.minToDriveStakePair) + (formWeightLumber * data.minToSetUpFormPerPound) + (data.minInstallFFPerRoll * length / 100) +
        (data.minToStripForm * formAreaLumber) + (data.minToCleanForm * formAreaLumber) +
        (data.minToLayoutOneResCorner * quantity + data.minToLayout12Feet * length / 20)

    resData.materialCostFF = Math.round(fabricCostFF)
    resData.lumberCostFF = Math.round(stakeCostFF + cleatCostFF + screedCostFF)
    resData.materialCostPlywood = Math.round(stakeCostLumber + cleatCostLumber)
    resData.lumberCostPlywood = Math.round(formCostLumber)
    resData.labourCostFF = Math.round(minutesFF / 60 * labourCost)
    resData.labourCostPlywood = Math.round(minutesLumber / 60 * labourCost)

    return resData
}

const commercialCostCompare = ({ width, height, length, quantity, lumberCost, plywoodCost, labourCost }) => {
    const resData = {}
    let costScreedFF = 0
    let costFabricFF = 0

    const costOneByFour = lumberCost / 1000 * 4 / 12 * data.oneByFourAdj
    const costTwoByFour = lumberCost / 1000 * 8 / 12 * data.twoByFourAdj
    const costTwoBySix = lumberCost / 1000 * data.twoBySixAdj
    const costTwoByEight = lumberCost / 1000 * 16 / 12 * data.twoByEightAdj

    switch (true) {
        case (height * 2 / data.heightAdjFF <= 50):
            const ff50RollQty = (((length + width) * 2 * quantity) / 100) * (1 + data.overlap / 100)
            costFabricFF = ff50RollQty * data.costFF50
            costScreedFF = (length + width) * 2 * (1 + data.woodWaste) * quantity / data.screedReuseComFF * costTwoBySix
            break
        case (height * 2 / data.heightAdjFF > 50 && height * 2  / data.heightAdjFF<= 62):
            const ff62RollQty = (((length + width) * 2 * quantity) / 100) * (1 + data.overlap / 100)
            costFabricFF = ff62RollQty * data.costFF62
            costScreedFF = (length + width) * 2 * (1 + data.woodWaste) * quantity / data.screedReuseComFF * costTwoBySix
            break
        case (height * 2 / data.heightAdjFF > 62 && height * 2 / data.heightAdjFF <= 74):
            const ff74RollQty = (((length + width) * 2 * quantity) / 100) * (1 + data.overlap / 100)
            costFabricFF = ff74RollQty * data.costFF74
            costScreedFF = (length + width) * 2 * (1 + data.woodWaste) * quantity / data.screedReuseComFF * costTwoByEight
            break
        case (height * 2 / data.heightAdjFF > 74):
            alert('Contact Fab-Form (888)303-3278 to discuss deep footings')
            break
    }

    const twoByFourWeight = data.weightLumberPerSqFt / 2 / 12 * 8

    const numberOfSupports = (width + length) * 2 / data.supportSpacing * quantity
    const twoByFourKickers = Math.sqrt(2) * height / 12 * (1 + data.woodWaste) * numberOfSupports
    const oneByFourStakes = data.oneByFourStakeLength * (1 + data.woodWaste) * numberOfSupports
    const twoByFourStakes = (height / 12 - 1) * (1 + data.stakeInGround) * (1 + data.woodWaste) * numberOfSupports
    const twoBySixStakes = (1 + data.woodWaste) * quantity
    const twoByFourPlywoodFrame = (((width * 12 / 16 + 1) * height / 12 + width * 2) + 
        (((length * 12 / 16 + 1) * height / 12 + length * 2)) * (1 + data.woodWaste)) * 2 * quantity

    const costSupportFF = costTwoByFour * (twoByFourKickers / data.kickerReuse + twoByFourStakes / data.stakeReuseComFF + oneByFourStakes) + 
        costTwoBySix * twoBySixStakes / data.stakeReuseComFF + costScreedFF

    const plywoodMaterial = plywoodCost * ((width + length) * 2 * height / 12 * (1 + data.woodWaste)) / data.formReuseComLumber

    const costSupportLumber = costTwoByFour * (twoByFourKickers / data.kickerReuse + twoByFourStakes / data.stakeReuseComLumber +
        twoByFourPlywoodFrame / data.twoByFourPlywoodFrameReuse) + costTwoByFour * oneByFourStakes / data.stakeReuseComLumber

    const formWeightFF = twoByFourWeight * (twoByFourStakes + twoByFourKickers) + 
        costScreedFF * data.screedReuseComFF * 1000 / lumberCost / 2 * data.weightLumberPerSqFt
    const formWeightLumber = twoByFourWeight * (twoByFourStakes + twoByFourKickers + twoByFourPlywoodFrame) + 
        data.plywoodWeightPerSquareFoot * (width + length) * 2 * height / 12

    const minutesFF = (formWeightFF * data.minToCarryFormPerPound) + 
        ((length + width) * 2 / 10 * data.minToLevelExcavationPer10Ft * data.levelAdjFF * quantity) + 
        ((length + width) * 2 / numberOfSupports * data.minToDriveStakePair * 2) + (formWeightFF * data.minToSetUpFormPerPound) + 
        (data.minInstallFFPerRoll * (length + width) * 2 / 100) + (data.minToStripForm * formWeightFF * data.stripAdjFF) + 
        (data.minToCleanForm * formWeightFF * data.cleanAdjFF) + (data.minToLayoutOneComCorner * 4 * quantity + data.minToLayout12Feet / 20 * (length + width) * 2 * quantity) 

    const minutesLumber = (formWeightLumber * data.minToCarryFormPerPound) + 
        ((length + width) * 2 / 10 * data.minToLevelExcavationPer10Ft * quantity) + 
        ((length + width) * 2 / numberOfSupports * data.minToDriveStakePair * 2) + (formWeightLumber * data.minToSetUpFormPerPound) + 
        (data.minInstallFFPerRoll * (length + width) * 2 / 100) * 0.0 + (data.minToStripForm * formWeightLumber) + (data.minToCleanForm * formWeightLumber) + 
        (data.minToLayoutOneComCorner * 4 * quantity + data.minToLayout12Feet / 20 * (length + width) * 2 * quantity)

    resData.materialCostFF = Math.round(costFabricFF)
    resData.lumberCostFF = Math.round(costSupportFF)
    resData.materialCostPlywood = Math.round(plywoodMaterial)
    resData.lumberCostPlywood = Math.round(costSupportLumber)
    resData.labourCostFF = Math.round(minutesFF / 60 * labourCost)
    resData.labourCostPlywood = Math.round(minutesLumber / 60 * labourCost)

    return resData
}
